import React, { useState } from 'react'
import Content from 'blocks.app/content/content'
import Catalog from 'blocks.app/catalog/catalog'
import { checkAvailableModule } from '../../../core/helpers/routes/routes'
import { GRADES_CATALOG_CONFIG, GRADES_CATALOG_TYPE, GradesSelectedItems } from './InstancesCatalogGrades-types'

const InstancesCatalogGradesComponent = () => {
    const [selectedItems, setSelectedItems] = useState<GradesSelectedItems>([])

    return (
        <Content title={GRADES_CATALOG_TYPE}>
            <Catalog
                type={GRADES_CATALOG_CONFIG.type}
                onSelect={setSelectedItems}
                selectedItems={selectedItems}
                fixedHeader={GRADES_CATALOG_CONFIG.fixedHeader}
                isExistRightToolbar={GRADES_CATALOG_CONFIG.isExistRightToolbar}
                treeView={GRADES_CATALOG_CONFIG.treeView}
            />
        </Content>
    )
}

export const InstancesCatalogGrades = checkAvailableModule('instancesCatalog/grades')
    ? InstancesCatalogGradesComponent
    : null
